var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3h8a2 2 0 0 1 2 2v16H6V5a2 2 0 0 1 2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13l6-6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17l3-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.2d6d1a64ace87b9b7c82c1beb8d554d4.svg";
export { ForwardRef as ReactComponent };